import { NexTable } from "../../components/Table/NexTable"
import { LookupDataType, LookupTableId, lookupTablesMap } from "../../models/LookupTable"
import { useLookupTableStore } from "../../zstore/LookupTableStore"

const disableRowWithKey: keyof LookupDataType = "inuse"

export const LookupTable = (props: {
    primaryKey: keyof LookupDataType
}) => {
    const { primaryKey } = props

    const rows = useLookupTableStore((state) => state.rows)
    const columns = useLookupTableStore((state) => state.columns)
    const selectedTableId = useLookupTableStore((state) => state.selectedTableId)
    const updateRows = useLookupTableStore((state) => state.updateRows)

    const tableIsAcq = selectedTableId === LookupTableId.acquisition_mode
    const selectedTableLabel = lookupTablesMap.get(selectedTableId)?.label

    return (
        <NexTable
            primaryKey={primaryKey}
            label={`Edit ${selectedTableLabel}`}
            columns={columns}
            rows={rows}
            updateTableRows={(
                rows: LookupDataType[],
                changedRows: LookupDataType[] | undefined,
                addedRow: LookupDataType | undefined,
            ) => {
                const rowsChanged = changedRows ?? []
                if (addedRow != null) {
                    rowsChanged.push(addedRow)
                }
                updateRows(rows, rowsChanged)
            }}
            tableRowOptions={{ disableRow: (row) => tableIsAcq && !!row[disableRowWithKey] }}
            canAddRow
            pasteColumns={["notes"]}
        />
    )
}
